<template>
  <div />
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';
  import { generateCategoryHash } from '@/helpers/menu-hash-helper';


  export default {
    name: 'CfMenuItemDetailPage',

    metaInfo() {
      const { selectedItem } = this;

      return {
        title: 'Menu',
        titleSuffix: selectedItem ? selectedItem.displayName : undefined,
        description: selectedItem ? (selectedItem.description || selectedItem.displayName) : undefined
      };
    },

    /* https://v3.router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards */
    beforeRouteEnter(to, from, next) {
      const { params } = to;

      const menuItemIdParam = params.menuItemId;

      if (menuItemIdParam) {
        next((vm) => {
          vm.routerNextHandler();
        });
      }
      else {
        next();
      }
    },

    data() {
      return {
        selectedCategoryHash: null
      };
    },

    computed: {
      ...mapGetters('menu', ['menu', 'selectedItem', 'selectedCategory']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['session', 'orderDetails']),
      ...mapGetters('orders', ['order', 'orders']),

      routeName() {
        const isOrderAtTable = this.orderDetails.orderType === 'table';

        return isOrderAtTable ? 'orderAtTableMenu' : 'orderMenu';
      },

      menuItemDetailsRouteName() {
        const isOrderAtTable = this.orderDetails.orderType === 'table';

        return isOrderAtTable ? 'orderAtTableMenuItemDetailsPage' : 'orderAheadMenuItemDetailsPage';
      },

      hasNotSelectedOrder() {
        return this.orderDetails.orderType === 'table' && !this.order.orderId && this.orders.length > 1;
      }
    },

    watch: {
      'selectedItem.favoriteItemId': 'favoriteItemIdWatchHandler'
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    methods: {
      createdHandler() {
        events.on('menu-item-modal:close', this.modalCloseHandler);
      },

      destroyedHandler() {
        events.off('menu-item-modal:close', this.modalCloseHandler);
      },

      routerNextHandler() {
        if (this.hasNotSelectedOrder) {
          this.openSelectOrderHandler();
        }
        else {
          this.openMenuItemDetails();
        }
      },

      openSelectOrderHandler() {
        const modalPayload = { orders: this.orders, callbackHandler: this.openMenuItemDetails };

        this.$openModal('select-table-top-device-order-modal', modalPayload, { isRequired: true });
      },

      async openMenuItemDetails() {
        const { params, query } = this.$route;

        const { menuItemId } = params;

        const { favoriteItemId, categoryId } = query;

        if (menuItemId) {
          await this.$store.dispatch('menu/selectItem', { favoriteItemId, itemId: menuItemId });

          if (categoryId) await this.$store.dispatch('menu/selectCategory', categoryId);

          // selectedItem loads asynchronously, so re-apply the title/description now that it's available.
          this.$applyMeta();

          this.selectedCategoryHash = this.selectedCategory && this.selectedCategory.displayName
            ? generateCategoryHash(this.selectedCategory.displayName)
            : null;

          const isReadOnly = this.getIsReadOnlyItem();

          this.$openModal('menuItem', { isReadOnly });
        }
        else {
          this.$closeModal('menuItem');
        }
      },

      getIsReadOnlyItem() {
        const isReadOnlyOrderAtTable = this.orderDetails.orderType === 'table' && this.merchant.features['readonly-order-at-table'];

        let isReadOnly = this.merchant.features['disable-ordering'];

        if (isReadOnlyOrderAtTable) {
          const isNotOrdable = Object.prototype.hasOwnProperty.call(this.selectedItem, 'readOnlyOrderable') ? !this.selectedItem.readOnlyOrderable : true;

          isReadOnly = isNotOrdable;
        }

        return isReadOnly;
      },

      favoriteItemIdWatchHandler(favoriteItemId) {
        if (favoriteItemId == this.$route.query.favoriteItemId) { // eslint-disable-line
          return;
        }

        const routerPayload = {
          name: this.routeName,
          params: this.$route.params,
          query: {
            favoriteItemId: favoriteItemId || undefined
          }
        };

        this.$router.replace(routerPayload);
      },

      modalCloseHandler() {
        const routerPayload = {
          name: this.routeName,
          params: {
            merchantId: this.$route.params.merchantId
          }
        };

        if (this.selectedCategoryHash) {
          routerPayload.hash = this.selectedCategoryHash;
        }

        this.$router.push(routerPayload);
      }
    }
  };
</script>
